import logo from './logo.svg';
import './App.css';

import a1 from "../src/imgs/ai.png"
import cloud from "../src/cloud.png"
import bulb from "../src/imgs/bulb1.png"
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import no from "./imgs/noimg.jpg"

function App() {

  const [flag, setflag] = useState(false)
  const [caption, setcaption] = useState('');
  const [file, setfile] = useState(null);
  const [preview, setpreviw] = useState('')

  const trig = () => {
    document.getElementById("chfile").click();
  }

  const getcaption = async () => {
    let form = new FormData();
    if (file !== null) {
      form.append("fileimg", file)
    }
    let resp = await fetch(`https://newdemodj.pythonanywhere.com/book`, {
      method: "post",
      body: form,
    });
    if (resp.ok) {
      let res = await resp.json();
      setcaption(res.msg)
      alert("success")
    }
  }

  const handleChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    setfile(selectedFile);
    setpreviw(URL.createObjectURL(selectedFile)); // ✅
    setflag(true);
  };

  return (
    <div className="App">
      <div className='container'>
        <div className='mainimg mt-5'>
          <img src={cloud} />
          <button onClick={trig}> Upload Image </button>
        </div>
        <input type='file' id='chfile' accept="image/*" onChange={handleChange} />
        <div className='in-btw'>
          <button className='btnk mt-5' onClick={() => getcaption(file)}> Generate Caption </button>
        </div>

        <div className='result mt-5'>
          <div className='row'>
            <div className='col-lg-5'>
              {
                flag ?
                  <img src={preview} className='img-fluid' />
                  :
                  <img src={no} className='img-fluid' />
              }

            </div>
            <div className='col-lg-7'>
              <p> {caption} </p>
            </div>
          </div>
        </div>

        <div className='use mt-5'>
          <div className='row'>
            <div className='col-lg-6'>
              <h3> How it works? </h3>
              <div className='row'>
                <div className='col-lg-4'>
                  <img src={a1} className='img-fluid' />
                </div>
                <div className='col-lg-8'>
                  <p> Blip model provided by Huggingface is use here. BLIP is a transformer model use Vision and Text Transformer
                    Vision Transfomer understands image and Text Transfomer gives output based on the given image.
                  </p>
                </div>
              </div>

            </div>
            <div className='col-lg-6'>
              <h3> Why use this tool? </h3>
              <div className='row'>
                <div className='col-lg-4'>
                  <img src={bulb} className='img-fluid' />
                </div>
                <div className='col-lg-8'>
                  <p>
                    Perfect for accessibility, social media, and creative projects. Our AI analyzes images to generate accurate,
                    meaningful captions and helpful responses, making visual content easier to understand and use across different platforms.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
